
import Likelihood from '@/components/actions/Likelihood.vue';
import MflsValues_rev from '@/modules/CA_SP/components/zz/MflsValues_rev.vue';
import mfl_modal from '@/components/modals/MflTable.vue';
import priority_modal from '@/components/modals/priority.vue';

import { priority_mtx,likelihood_values,priority_colors } from '@/objects/general.js';
import { getImpactTypes, usesGlobalRiskStandardV2 } from '@/objects/mfl_global_risk.js';
import { mfl_financial,inpAreasNames } from '@/functions/general.js';
const getFiscalYear = (date/* : string): number => { */) => {
  const dateObject = new Date(Date.parse(date))
  return dateObject.getFullYear() + Math.floor((dateObject.getUTCMonth())  / 6)
}

export default {
  components:{Likelihood,MflsValues_rev,mfl_modal,priority_modal},
  data() {
    return {
      re_calc_ebit:0,
      dialogMfl:false,
      priority_dialog:false,
      selected_ca:{},
      BHP_SHARE:0.575,
      ebit_date:null,
      enable_ignore_ebit_calculation:true,
    };
  },
  computed:{
    listImpactedAreas() {return this.$store.getters.listImpactedAreas},
    fiscal_years() {return this.$store.getters.fiscal_years},
    p_color(){ return priority_colors[this.selectedItem.priority] },
    impact_types() {
      return getImpactTypes(this.selectedItem.global_risk_standard_version);
    },
    mfl_can_edit() {
      const editable = usesGlobalRiskStandardV2(this.selectedItem.global_risk_standard_version)
        ? ['reputation', 'legal', 'sustainability', 'health_and_safety']
        : ['reputation', 'legal', 'community', 'environment', 'health_and_safety'];
      return editable.includes(this.selectedItem.impact_type);
    },
    impacted_areas_names(){ return inpAreasNames(this.selected_ca.impacted_areas||[])},
    selected_mfl_key(){ return `mfl_${this.selectedItem.impact_type}`},
    p_x(){
      const x = this.selectedItem[`mfl_${this.selectedItem.impact_type}`] || 0;
      return x>0?(x-1):undefined;
    },
    p_y(){
      let y;
      likelihood_values.forEach((v,i)=>this.selectedItem.likelihood===v.factor && (y=i));
      return y
    },
    sca_impacted_areas(){ return this.selected_ca != null? this.selected_ca.impacted_areas: [] },
    ebit() {
      this.re_calc_ebit;
      return this.calc_ebit()
    },
  },
watch:{
    'selectedItem.likelihood'(){ this.set_priority() },
    'selectedItem.severity'(){ this.set_rrr() },
    'selectedItem.creation_date'(){ this.set_computed_financial_mfl() },
    'selectedItem.mfl_days'(){ this.set_computed_financial_mfl() },
    'selectedItem.ebit'(){ this.set_computed_financial_mfl() },
    'selectedItem.impact_percentage'(){ this.set_computed_financial_mfl() },
    'selected_ca'(){
      this.set_computed_financial_mfl();
      if (this.selectedItem.impact_percentage === null && (this.selected_ca||{}).impact_percentage) {
        this.selectedItem.impact_percentage = this.selected_ca.impact_percentage
      }
    },
    'selectedItem.impact_type'(v,old){
      if (v != 'financial') this.selectedItem.mfl_days = null;
      if (old && old != 'financial') this.selectedItem[`mfl_${old}`] = null;
    },
    'selectedItem.mfl_health_and_safety'(){ this.set_priority()},
    'selectedItem.mfl_environment'(){ this.set_priority()},
    'selectedItem.mfl_community'(){ this.set_priority()},
    'selectedItem.mfl_legal'(){ this.set_priority()},
    'selectedItem.mfl_reputation'(){ this.set_priority()},
    'selectedItem.mfl_sustainability'(){ this.set_priority()},
    'selectedItem.mfl_financial'(){ this.set_priority()},
    'selectedItem.computed_financial_mfl'(){
      this.selectedItem.mfl_financial = mfl_financial({
        computed_financial_mfl: this.selectedItem.computed_financial_mfl,
        global_risk_standard_version: this.selectedItem.global_risk_standard_version,
      });
    },
  },
  methods:{
    calc_ebit(){
      let TE = 0;
      if (this.selectedItem.impact_type === 'financial') {
        if (this.enable_ignore_ebit_calculation && this.selectedItem.ignore_ebit_calculation) return this.selectedItem.ebit;

        const {listImpactedAreas} = this;
        let fiscal_year_ebit= getFiscalYear(this.ebit_date) ;//2021;
        let asset= {impacted_areas: this.sca_impacted_areas ,fiscal_year_ebit };

        if(asset.fiscal_year_ebit != undefined) {
          let {year} = (this.fiscal_years.find(f => f.year === asset.fiscal_year_ebit)||{});
          if (!year) {
            const clyr = this.fiscal_years.map(item => item.year).sort((a,b) => b - a).find(y=>asset.fiscal_year_ebit>y);
            year = (this.fiscal_years.find(f => f.year === clyr)||{}).year
            asset = {impacted_areas: this.sca_impacted_areas ,fiscal_year_ebit:clyr };
          }

          if (year) {
            const IA = asset.impacted_areas || [];
            const ias = listImpactedAreas.map(m=> m.ebits.find(f=>f.fiscal_year===year));
            ias.forEach(a => TE += IA.includes(a.impacted_area)? a.value: 0);
          }
        }
      }
      if (this.enable_ignore_ebit_calculation) {
        if (!this.selectedItem.ignore_ebit_calculation) this.selectedItem.ebit = TE;
      } else this.selectedItem.ebit = TE;

      return TE;
    },
    set_priority() {
      this.selectedItem.priority = [this.p_x,this.p_y].includes(undefined)? null: `P${priority_mtx[this.p_y][this.p_x]}`;
      this.selectedItem.severity = this.p_x + 1;
      this.set_rrr()
    },
    set_rrr(){
      this.selectedItem.rrr = (this.selectedItem.likelihood||0) * (this.selectedItem.severity||0)
    },
    set_computed_financial_mfl() {
      this.selectedItem.computed_financial_mfl = parseInt(((this.selectedItem.mfl_days||0) * (this.selectedItem.impact_percentage||0) * (this.selectedItem.ebit||0) * this.BHP_SHARE)/100)
    },
  }
};
